<template>
  <div class="wrapper">
    <div class="tab-wrap">
      <div class="tab-btn">
        <span
          :class="statisticPeriod === 'month' ? 'active' : ''"
          @click="changeStats('month')"
          >当月</span
        >
        <span
          :class="statisticPeriod === 'season' ? 'active' : ''"
          @click="changeStats('season')"
          >季度</span
        >
        <span
          :class="statisticPeriod === 'annual' ? 'active' : ''"
          @click="changeStats('annual')"
          >年度</span
        >
      </div>
    </div>
    <div class="scroll-part">
      <div class="out-card">
        <div class="out-total">
          <p class="total-name">销项总额（元）</p>
          <p class="total-money">{{ convertNumber(outStats.totalAmount) || '0.00' }}</p>
        </div>
        <div class="out-detail">
          <div>
            <p>税额（元）</p>
            <p>{{convertNumber(outStats.totalTaxAmount)}}</p>
          </div>
          <div>
            <p>开票张数（张）</p>
            <p>{{ outStats.totalNum || 0}}</p>
          </div>
        </div>
      </div>
      <div class="in-card">
        <div class="in-total">
          <p class="total-name">进项总额（元）</p>
          <p class="total-money">{{ convertNumber(inStats.totalAmount) || '0.00' }}</p>
        </div>
        <div class="in-detail">
          <div>
            <p>税额（元）</p>
            <p>{{convertNumber(inStats.totalTaxAmount) || '0.00'}}</p>
          </div>
          <div>
            <p>开票张数（张）</p>
            <p>{{ inStats.totalNum || 0 }}</p>
          </div>
        </div>
      </div>
      <div class="total-card">
        <div>
          <p>累计数额</p>
          <div>
            <i class="iconfont">&#xe6dc;</i>
          </div>
          <p>{{ convertNumber(totalAmount) || 0 }}</p>
        </div>
        <div>
          <p>累计税额</p>
          <div class="orange-icon">
            <i class="iconfont">&#xe6db;</i>
          </div>
          <p>{{ convertNumber(totalTaxAmount)|| 0 }}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  Row,
  Col,
  Notify
} from 'vant'
import { invoiceRequest, officialAccountRequest } from '@services'
import {
  ConvertNumber,
  onCount
} from '@utils/basicUtil'
import moment from 'moment'
export default {
  components: {
    [Row.name]: Row,
    [Col.name]: Col
  },
  props: {},
  data () {
    return {
      statisticPeriod: 'month',
      dataSource: {},
      inDataSource: {
        currMonthStatistics: {},
        quarterStatistics: {},
        yearStatistics: {}
      },
      outStats: {
        totalAmount: 0,
        totalNum: 0,
        totalTaxAmount: 0
      },
      inStats: {
        totalAmount: 0,
        totalNum: 0,
        totalTaxAmount: 0
      }
    }
  },
  computed: {
    totalAmount () {
      return onCount.sub(this.outStats.totalAmount, this.inStats.totalAmount)
    },
    totalTaxAmount () {
      return onCount.sub(this.outStats.totalTaxAmount, this.inStats.totalTaxAmount)
    }
  },
  watch: {},
  created () {},
  mounted () {
    this.getStatistics()
    this.getInData('month')
    this.getInData('season')
    this.getInData('annual')
  },
  activated () {},
  updated () {},
  methods: {
    changeStats (period) {
      this.statisticPeriod = period
      if (period === 'month') {
        this.outStats = this.dataSource.currMonthStatistics
        this.inStats = this.inDataSource.currMonthStatistics
      }
      if (period === 'season') {
        this.outStats = this.dataSource.quarterStatistics
        this.inStats = this.inDataSource.quarterStatistics
      }
      if (period === 'annual') {
        this.outStats = this.dataSource.yearStatistics
        this.inStats = this.inDataSource.yearStatistics
      }
    },
    convertNumber (data) {
      return ConvertNumber(data) || '0.00'
    },
    async getStatistics () {
      const data = await invoiceRequest.statistics.getStatistics({})
      console.log(data)
      if (data.success) {
        this.dataSource = data.result
        this.changeStats('month')
      } else {
        if (data.success === false) {
          Notify({ type: 'danger', message: data.message })
        }
      }
    },
    async getInData (period) {
      let obj = {
        'month': {
          startTime: moment().startOf('month').format('YYYY-MM-DD HH:mm:ss'),
          endTime: moment().endOf('month').format('YYYY-MM-DD HH:mm:ss')
        },
        'season': {
          startTime: moment().startOf('quarter').format('YYYY-MM-DD HH:mm:ss'),
          endTime: moment().endOf('quarter').format('YYYY-MM-DD HH:mm:ss')
        },
        'annual': {
          startTime: moment().startOf('year').format('YYYY-MM-DD HH:mm:ss'),
          endTime: moment().endOf('year').format('YYYY-MM-DD HH:mm:ss')
        }
      }
      let params = {
        ...obj[period]
      }
      const data = await officialAccountRequest.weChat.getTicketStatistics(params)
      if (data.success) {
        let name = ''
        if (period === 'month') {
          name = 'currMonthStatistics'
        } else if (period === 'season') {
          name = 'quarterStatistics'
        } else if (period === 'annual') {
          name = 'yearStatistics'
        }
        this.inDataSource = {
          ...this.inDataSource,
          [name]: {
            ...this.inDataSource[name],
            totalAmount: data.result.sumAmountWithTax,
            totalNum: data.result.ticketCounts,
            totalTaxAmount: data.result.sumTaxAmount
          }
        }
        if (name === 'currMonthStatistics') {
          this.inStats = this.inDataSource.currMonthStatistics
        }
      } else {
        Notify({ type: 'danger', message: data.message })
      }
    }
  }
}
</script>
<style lang="less" scoped src="./style.less"/>
